import gql from 'graphql-tag';

export const GET_PROFILE = gql`
  {
    userProfile @client {
      merchantId
      merchantName
      email
      emailVerified
      familyName
      givenName
      userType
      userRole
      sub
      identities {
        dateCreated
        issuer
        primary
        providerName
        providerType
        userId
      }
    }
  }
`;

export const SET_PROFILE = gql`
  mutation SetProfile($profile: Profile!) {
    setProfile(profile: $profile) @client
  }
`;

export const CREATE_SPLITIO_CLIENT = gql`
  mutation CreateSplitioClient {
    createSplitioClient(key: $key) @client
  }
`;

export const GET_MERCHANTS = gql`
  query GetMerchants($params: MerchantSearchInput) {
    merchantList(params: $params) {
      result {
        merchantName
        merchantId
      }
    }
  }
`;

export const REVOKE_TOKEN = gql`
  mutation RevokeToken($clientId: String!, $token: String!) {
    revokeToken(clientId: $clientId, token: $token) {
      error {
        message
        code
      }
      success {
        message
        code
      }
    }
  }
`;
